export default "__VITE_ASSET__CbwSrwLO__"